import type { BoggleResolvedChallengeBonus } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBonusDisplayFromDefinition } from '~/boggle/config/bonuses/formatResolvedBonusDisplay'
import type { BoggleChallengeBonusResolverContext } from '~/boggle/lib/challenge/resolveModFamily'
import type { BoggleChallengeBonusDefinition } from '../bonusDefinition'
import type { BoggleBonusValue } from '../types'

export const doubleLetterBonusDefinition: BoggleChallengeBonusDefinition = {
  description: 'Word includes the same letter twice in a row',
  id: 'double-letter',
  name: 'Doubles',
  parameterDefinitions: {},
  selectionWeight: 1,
  shortLabel: 'Double up',
}

export function resolveDoubleLetterBonus(
  family: BoggleChallengeBonusDefinition,
  rngState: number,
  _context: BoggleChallengeBonusResolverContext,
  value: BoggleBonusValue,
): {
  mod: BoggleResolvedChallengeBonus
  rngState: number
} {
  const display = formatResolvedBonusDisplayFromDefinition(family, {})

  return {
    mod: {
      description: display.description,
      effects: [],
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: [{ kind: 'requires-consecutive-doubled-letter' }],
      parameters: {},
      shortLabel: display.shortLabel,
      value,
    },
    rngState,
  }
}
